module.exports = " <div id=basic _v-07f7c4b0=\"\"></div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-07f7c4b0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BraBasic.vue
// module id = 10
// module chunks = 1